/*!
* name ZJX  登录页
* Copyright 2018-2019
*/
<template>
  <div class="login_content_bg">
    <div class="login_content_box">
      <div class="login_content_banner">
        <el-carousel height="580px" :interval="5000" arrow="never" indicator-position="none">
          <el-carousel-item v-for="(item,index) in imgList" :key="index">
            <img class="banner_img" :src="item.src" :alt="item.id">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="login_content_logs">
        <div class="login_content_logo">
          <img src="../../assets/images/lh.png" alt>
        </div>
        <div class="login_content_texts">{{title}}</div>
        <div class="login_content_tabs" v-if="showTabName != 2" v-show="showTabName != 3">
          <div
            v-for="(item,index) in logTabs"
            :class="index == showTabName ? showColor : ''"
            @click="activeTab(item)"
            class="login_content_tabs_left"
            :key="index"
          >
            <span>{{item.tabName}}</span>
          </div>
        </div>
        <div class="login_content_user">
          <div class="login_content_user_account">
            <div>
              <!--账号登录S-->
              <template v-if="showTabName == 0">
                <el-input
                  v-model="logData.userName"
                  @focus="onFocus('userName',0)"
                  placeholder="请输入邮箱或手机号"
                  maxlength="30"
                ></el-input>
                <span class="cur_color">{{errorData}}</span>
                <el-input
                  class="login_content_password login_content_password_set"
                  type="password"
                  v-model="logData.userPassWord"
                  placeholder="请输入登录密码"
                  @focus="onFocus('userPassWord',0)"
                ></el-input>
                <span class="cur_color">{{errorDataPassWord}}</span>
              </template>
              <!--账号登录E-->
              <!--手机号登录S-->
              <template v-else-if="showTabName == 1">
                <el-input
                  maxlength="11"
                  v-model="logData.phone"
                  @focus="onFocus('shoujihaodenglu',1)"
                  placeholder="请输入手机号"
                ></el-input>
                <span class="cur_color">{{errorDataPhone}}</span>
                <div>
                  <el-input
                    maxlength="4"
                    @focus="onFocus('shoujihaodenglu1',1)"
                    class="login_content_code"
                    type
                    v-model="logData.senCode"
                    placeholder="请输入验证码"
                  ></el-input>
                  <el-button
                    class="login_content_code_btn"
                    :disabled="disabled"
                    @click="sendCode"
                  >{{btnText}}
                  </el-button>
                </div>
                <span class="cur_color">{{errorDataCode}}</span>
              </template>
              <!--手机号登录E-->
              <!--忘记密码S-->
              <template v-else-if="showTabName == 2">
                <el-input
                  v-model="logData.mailbox"
                  placeholder="请输入您注册的邮箱或手机号码"
                  @focus="onFocus('wangjimima',2)"
                  maxlength="50"
                ></el-input>
                <span class="cur_color">{{errorMailbox}}</span>
                <div>
                  <el-input
                    maxlength="4"
                    @focus="onFocus('wangjimima1',2)"
                    class="login_content_code"
                    type="mailbox"
                    v-model="logData.mailboxCode"
                    placeholder="请输入邮箱验证码"
                  ></el-input>
                  <el-button
                    class="login_content_code_btn"
                    :disabled="disabled"
                    @click="sendCode"
                  >{{btnText}}
                  </el-button>
                  <span class="cur_color">{{errorMailboxCode}}</span>
                </div>
                <el-input
                  type="password"
                  @focus="onFocus('wangjimima3',2)"
                  style="margin-top: 26px;"
                  v-model="logData.newPassWord"
                  placeholder="设置您新的登录密码"
                ></el-input>
                <span class="cur_color">{{errorMailPassWord}}</span>
                <el-input
                  type="password"
                  @focus="onFocus('wangjimima4',2)"
                  style="margin-top: 26px;margin-bottom: 30px;"
                  v-model="logData.repeatPassWord"
                  placeholder="再次输入您新的密码"
                ></el-input>
                <span class="cur_color">{{errorMailNewPassWord}}</span>
              </template>
              <!--忘记密码E-->
              <!--注册S-->
              <template v-else-if="showTabName == 3">
                <div class="login_content_st">
                  <span>我是：</span>
                  <span
                    @click="clickColor(item)"
                    v-for="(item,index) in logDataTitel"
                    :key="index"
                    :class="[item.class,hoverArr[index]]"
                  >{{item.text}}</span>
                </div>
                <el-input
                  v-model="logData.registerPhone"
                  @focus="onFocus('zhuce',3)"
                  placeholder="请输入邮箱或手机号"
                  maxlength="30"
                ></el-input>
                <span class="cur_color">{{errorPhone}}</span>
                <div>
                  <el-input
                    maxlength="4"
                    class="login_content_code"
                    type="text"
                    v-model="logData.registerSenCode"
                    placeholder="请输入验证码"
                    @focus="onFocus('zhuce1',3)"
                  ></el-input>
                  <el-button
                    class="login_content_code_btn"
                    :disabled="disabled"
                    @click="sendCode"
                  >{{btnText}}
                  </el-button>
                  <span class="cur_color">{{errorCode}}</span>
                </div>
                <el-input
                  type="password"
                  style="margin-top: 26px;margin-bottom: 30px;"
                  v-model="logData.registerPassWord"
                  placeholder="设置登录密码,支持8-20位数字和字母"
                  @focus="onFocus('zhuce2',3)"
                  maxlength="20"
                  minlength="8"
                ></el-input>
                <span class="cur_color">{{errorDataPs}}</span>
              </template>
              <!--注册E-->
              <div
                class="login_content_user_account_zd"
                v-if="showTabName != 2"
                v-show="showTabName != 3"
              >
                <el-checkbox v-model="isChecked">自动登录</el-checkbox>
                <span>|</span>
                <span @click="forgetPassword">忘记密码</span>
                <span @click="freeRegistration">免费注册</span>
              </div>
            </div>
            <div class="login_content_user_account_btn">
              <div @click="login">{{logText}}</div>
            </div>
            <div class="log_lp" v-if="showTabName == 2">
              立刻返回
              <span @click="goLogin">去登录</span>
            </div>
            <div class="log_lp" v-if="showTabName == 3">
              已经有账号？
              <span @click="goLogin">去登录</span>
            </div>
          </div>
          <div
            class="login_content_user_third_party"
            v-if="showTabName != 2"
            v-show="showTabName != 3"
          >
            <div class="login_content_user_third_party_one"></div>
            <span>第三方账号登录</span>
            <div class="login_content_user_third_party_authorization">
              <ul>
                <li>
                  <img @click="weChatlogin" src="../../assets/images/weixin.png" alt>
                </li>
                <!--<li>-->
                <!--<img src="../../assets/images/weibo.png" alt>-->
                <!--</li>-->
                <!--<li>-->
                <!--<img src="../../assets/images/qq@2x.png" alt>-->
                <!--</li>-->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import cacheUtils from '@/common/cacheUtils' // 调用缓存
import apiInterface from '@/api/index' // 接口
import localStorage from '../../assets/js/common/localStorage'

export default {
  data () {
    return {
      imgList: [
        {
          id: 1,
          src:
            "http://lehuawang.dzhhb.com/imgs/pic1.png"
        },
        {
          id: 2,
          src:
            "http://lehuawang.dzhhb.com/imgs/pic2.png"
        },
        {
          id: 3,
          src:
            "http://lehuawang.dzhhb.com/imgs/pic3.png"
        }
      ], //存放img列表的数组
      logDataTitel: [
        {
          id: 1,
          text: '教师',
          class: 'login_content_cur'
        },
        {
          id: 2,
          text: '学生',
          class: 'login_content_cur_tl'
        }
      ],
      hoverArr: ['cur_hover', ''],
      title: '乐画就是快乐绘画', // 登录页面titel内容
      logTabs: [
        { id: 1, tabName: '用户密码登录' },
        { id: 2, tabName: '动态验证码登录' }
      ], // 切换内容对象
      showTabName: 0, // 初始化定义选中哪一个
      showColor: 'tab_cur', // 定义默认样式
      isChecked: false, // 是否选中自动登录
      userName: '', // 用户名
      userPass: '', // 密码
      btnText: '发送动态密码', // 发送验证码文案
      disabled: false, // 初始化不禁用获取验证码
      codeTime: 60, // 初始化60秒倒计时
      logData: {
        // 用户密码登录
        userName: '',
        userPassWord: '',
        // 手机号登录
        phone: '',
        senCode: '',
        // 忘记密码登录
        mailbox: '',
        mailboxCode: '',
        newPassWord: '',
        repeatPassWord: '',
        // 注册成功后登录
        registerPhone: '',
        registerSenCode: '',
        registerPassWord: '',
        codeMsm: '' // 获取到验证码
      },
      logText: '登录', // 登录文案
      errorData: '', // 账号登录提示错误
      errorDataPassWord: '', // 账号登录密码错误提示
      errorDataPhone: '', // 动态密码登录
      errorDataCode: '', // 动态验证码
      errorMailbox: '', // 邮箱错误提示
      errorMailboxCode: '', // 邮箱验证码错误提示
      errorMailPassWord: '', // 密码不能为空
      errorMailNewPassWord: '', // 密码不能为空
      errorPhone: '', // 注册错误提示
      errorCode: '', // 注册验证码错误
      errorDataPs: '', // 注册错误密码提示
      isTeacherStudent: '1' // 是老师还是还是学生
    }
  },
  computed: {
    loginType () {
      return localStorage.get('loginType') || 0
    }
  },
  methods: {
    // 微信登录
    weChatlogin () {
      window.location.href = 'http://api.lehuawang.dzhhb.com/wechat-login'
    },
    // 去登录
    goLogin () {
      this.codeTime = 0
      this.btnText = '发送动态密码'
      this.disabled = false
      this.showTabName = 0
      this.logText = '登录'
      localStorage.set('loginType', '0')
    },
    // tab切换登录方式
    activeTab (item) {
      this.showTabName = item.id == 1 ? 0 : 1
    },
    // 颜色切换
    clickColor (item) {
      let id = item.id - 1
      this.hoverArr = this.hoverArr.map((item, index) => {
        return id == index ? 'cur_hover' : ''
      })
      this.isTeacherStudent = item.id
    },
    // 发送验证码
    sendCode () {
      if (this.showTabName == 1) {
        // 手机验证码登录
        if (this.logData.phone == '') {
          this.errorDataPhone = '手机号不能为空'
          return
        } else if (!/^1[34578]\d{9}$/.test(this.logData.phone)) {
          this.$message.error('手机号格式错误')
          return
        } else {
          this.codeTime = 60
          this.disabled = true
          this.sendTimerCode()
        }
      } else if (this.showTabName == 2) {
        // 忘记密码
        var myreg = /^[1][3,4,5,7,8][0-9]{9}$/
        if (!myreg.test(this.logData.mailbox)) {
          var eml = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
          if (this.logData.mailbox == '') {
            this.errorMailbox = '邮箱不能为空'
            return
          } else if (!eml.test(this.logData.mailbox)) {
            this.$message.error('请输入正确邮箱或者手机号')
            return
          } else {
            this.codeTime = 60
            this.disabled = true
            this.sendTimerCode()
          }
        } else {
          if (this.logData.mailbox.length == 11) {
            if (!/^1[34578]\d{9}$/.test(this.logData.mailbox)) {
              this.$message.error('请输入正确手机号')
              return
            } else {
              this.codeTime = 60
              this.disabled = true
              this.sendTimerCode('2')
            }
          }
        }
      } else if (this.showTabName == 3) {
        // 注册
        if (this.logData.registerPhone == '') {
          this.errorPhone = '手机号或者邮箱不能为空'
          return
        } else {
          var myreg = /^[1][3,4,5,7,8][0-9]{9}$/
          if (!myreg.test(this.logData.registerPhone)) {
            var eml = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
            if (!eml.test(this.logData.registerPhone)) {
              this.$message.error('请输入正确邮箱或者手机号')
              return
            } else {
              this.codeTime = 60
              this.disabled = true
              this.sendTimerCode('1')
            }
          } else {
            if (this.logData.registerPhone.length == 11) {
              if (!/^1[34578]\d{9}$/.test(this.logData.registerPhone)) {
                this.$message.error('请输入正确手机号')
                return
              } else {
                this.codeTime = 60
                this.disabled = true
                this.sendTimerCode('2')
              }
            }
          }
        }
        // if (this.logData.registerPhone == "") {
        //   this.errorPhone = "手机号或者邮箱不能为空";
        //   return;
        // }
        // if (this.logData.registerPhone.length == 11) {
        //   if (!/^1[34578]\d{9}$/.test(this.logData.registerPhone)) {
        //     this.$message.error("请输入正确手机号");
        //     return;
        //   } else {
        //     this.codeTime = 60;
        //     this.disabled = true;
        //     this.sendTimerCode();
        //     this.timer();
        //   }
        // }
      }
    },
    // 启动定时器发送验证码
    timer () {
      if (this.codeTime > 0) {
        this.codeTime--
        this.btnText = '重新获取(' + this.codeTime + '秒)'
        setTimeout(this.timer, 1000)
      } else {
        this.codeTime = 0
        this.btnText = '发送动态密码'
        this.disabled = false
      }
    },
    // 发送验证码接口
    async sendTimerCode (state) {
      if (this.showTabName == 1) {
        // 获取手机验证码
        try {
          let pdata = await this.$xhr.get(apiInterface.smsCaptcha, {
            params: { type: 'login', phone: this.logData.phone }
          })
          debugger
          if (pdata.status_code == 200) {
            this.timer()
          } else {
            this.$message.error(pdata.message)
            this.disabled = false
          }
        } catch (error) {
          this.$message.error(error.message)
          this.disabled = false
        }
      } else if (this.showTabName == 2) {
        // 获取邮箱验证码
        try {
          let pdata;
          var myreg = /^[1][3,4,5,7,8][0-9]{9}$/
          if (!myreg.test(this.logData.mailbox)) {
            var eml = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
            if (eml.test(this.logData.mailbox)) {
              pdata = await this.$xhr.get(apiInterface.getEmailCaptcha, {
                params: {type: 'forgetpw', email: this.logData.mailbox}
              })
            }
          }else{
            pdata = await this.$xhr.get(apiInterface.smsCaptcha, {
              params: {type: 'forgetpw', phone: this.logData.mailbox}
            })
          }
          if (pdata.status_code == 200) {
            this.timer()
          } else {
            this.$message.error(pdata.message)
            this.disabled = false
          }
        } catch (error) {
          this.$message.error(error.message)
          this.disabled = false
        }
      } else if (this.showTabName == 3) {
        // 注册邮箱
        try {
          if (state == '1') {
            let pdata = await this.$xhr.get(apiInterface.getEmailCaptcha, {
              params: { type: 'signup', email: this.logData.registerPhone }
            })
            if (pdata.status_code == 200) {
              this.timer()
            } else {
              this.$message.error(pdata.message)
              this.disabled = false
            }
          } else {
            let pdata = await this.$xhr.get(apiInterface.smsCaptcha, {
              params: { type: 'signup', phone: this.logData.registerPhone }
            })
            if (pdata.status_code == 200) {
              this.timer()
            } else {
              this.$message.error(pdata.message)
              this.disabled = false
            }
          }
        } catch (error) {
          this.$message.error(error.message)
          this.disabled = false
        }
      }
    },
    // 忘记密码
    forgetPassword () {
      this.codeTime = 0
      this.btnText = '发送动态密码'
      this.disabled = false
      this.showTabName = 2
      this.logText = '完成'
      localStorage.set('loginType', '2')
    },
    // 免费注册
    freeRegistration () {
      this.codeTime = 0
      this.btnText = '发送动态密码'
      this.disabled = false
      this.showTabName = 3
      this.logText = '注册'
      localStorage.set('loginType', '3')
    },
    // 获取焦点后红色文字提示消失
    onFocus (status, data) {
      if (data == 0) {
        status == 'userName'
          ? (this.errorData = '')
          : (this.errorDataPassWord = '')
      } else if (data == 1) {
        status == 'shoujihaodenglu'
          ? (this.errorDataPhone = '')
          : (this.errorDataCode = '')
      } else if (data == 2) {
        status == 'wangjimima'
          ? ((this.errorMailbox = ''), (this.errorMailPassWord = ''))
          : ((this.errorMailboxCode = ''), (this.errorMailNewPassWord = ''))
        if (status == 'wangjimima3') {
          this.errorMailPassWord = ''
        }
        if (status == 'wangjimima4') {
          this.errorMailNewPassWord = ''
        }
      } else if (data == 3) {
        if (status == 'zhuce') {
          this.errorPhone = ''
        } else if (status == 'zhuce1') {
          this.errorCode = ''
        } else if (status == 'zhuce2') {
          this.errorDataPs = ''
        }
      }
    },
    // 登录成功后跳转到主页面
    async login () {
        debugger
      if (this.showTabName == 0) {
        // 用户名密码登录
        if (this.logData.userName == '') {
          this.errorData = '邮箱手机或登录密码不能为空'
          return
        } else if (this.logData.userPassWord == '') {
          this.errorDataPassWord = '密码不能为空'
          return
        } else if (this.showTabName.length == 11) {
          if (!/^1[34578]\d{9}$/.test(this.logData.userName)) {
            this.$message.error('请输入正确的手机号')
            return
          }
        } else {
          try {
            let userToken = await this.$xhr.post(apiInterface.login, {
              account: this.logData.userName,
              // captcha: "3414",
              password: this.logData.userPassWord
            })
            if (userToken.data.token) {
              cacheUtils.cookie.setObject('Token', userToken.data.token)
              this.$router.push({ path: '/sharingcenter' })
            }
          } catch (error) {
            this.$message.error(error.message)
          }
        }
      } else if (this.showTabName == 1) {
        // 手机号登录
        if (this.logData.phone == '') {
          this.errorDataPhone = '手机号不能为空'
          return
        } else if (this.logData.senCode == '') {
          this.errorDataCode = '验证码不能为空'
          return
        } else {
          try {
            let userToken = await this.$xhr.post(apiInterface.phoneLogin, {
              account: this.logData.phone, //"teacher@lehua.com",
              captcha: this.logData.senCode
            })
            if (userToken.data.token) {
              cacheUtils.cookie.setObject('Token', userToken.data.token)
              this.$router.push({ path: '/sharingcenter' })
            }
          } catch (error) {
            this.$message.error(error.message)
          }
        }
      } else if (this.showTabName == 2) {
        if (this.logData.mailbox == '') {
          this.errorMailbox = '邮箱不能为空'
          return
        } else if (this.logData.mailboxCode == '') {
          this.errorMailboxCode = '验证码不能为空'
          return
        } else if (this.logData.newPassWord == '') {
          this.errorMailPassWord = '密码不能为空'
          return
        } else if (this.logData.newPassWord != this.logData.repeatPassWord) {
          this.$message.error('新密码与重复密码不匹配')
          return
        } else {
          try {
            let userStatus = await this.$xhr.post(apiInterface.resetPassword, {
              account: this.logData.mailbox, // "teacher@lehua.com",
              captcha: this.logData.mailboxCode,
              'new-password': this.logData.repeatPassWord
            })
            console.log(userStatus)
            if (userStatus.message == '密码修改成功') {
              this.$message.success('密码修改成功')
              let _this = this
              setTimeout(function () {
                history.go(0)
              }, 2000)
            }
          } catch (error) {
            this.$message.error(error.message)
          }
        }
      } else if (this.showTabName == 3) {
        // 注册
        if (this.logData.registerPhone == '') {
          this.errorPhone = '手机号或者邮箱不能为空'
          return
        } else if (this.logData.registerSenCode == '') {
          // this.errorCode = "验证码不能为空";
          this.$message.error('验证码不能为空')
          return
        } else if (this.logData.registerPassWord == '') {
          this.errorDataPs = '密码不能为空'
          return
        } else if (!/^((?![^a-zA-Z!@#$%^&*()]+$)(?![!@#$%^&*()]+$)).{8,20}/.test(this.logData.registerPassWord) || this.logData.registerPassWord.length < 8) {
          this.errorDataPs = '密码只能输入8-20位数字和字母'
          return
        } else {
          try {
            let userToken = await this.$xhr.post(apiInterface.signup, {
              type_id: this.isTeacherStudent,
              account: this.logData.registerPhone, //"teacher@lehua.com",
              captcha: this.logData.registerSenCode.toString(),
              password: this.logData.registerPassWord
            })
            if (userToken.data.token) {
              cacheUtils.cookie.setObject('Token', userToken.data.token)
              this.$router.push({ path: '/sharingcenter' })
            }
          } catch (error) {
            this.$message.error(error.message)
          }
        }
      }
    },
    // 第三方登录需要截取的tonken
    GetRequest (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg) //search,查询？后面的参数，并匹配正则
      if (r != null) return unescape(r[2])
      return null
    }
  },
  created () {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 || keycode == 100) {
        that.login();// 登录方法名
      }
    }
      if(cacheUtils.cookie.getObject('Token') != null){
        this.$router.push({ path: '/sharingcenter' })
      }else {
        console.log('this.loginType:', this.loginType)
        if (this.$route.query.id) { // 来源注册还是登录
          this.showTabName = this.$route.query.id
        } else {
          this.showTabName = this.loginType == 2 ? 0 : this.loginType
          if (this.loginType == 0) {
            this.logText = '登录'
          } else if (this.loginType == 2) {
            this.logText = '登录'
          } else {
            this.logText = '注册'
          }
        }
        if (this.hoverArr[0] == 'cur_hover') {
          //等于1是老师
          this.isTeacherStudent = 1
        }
        // 判断url 是否携带token
        if (this.GetRequest('status_code') == 200) {
          if (this.GetRequest('token') != null) {
            cacheUtils.cookie.setObject('Token', this.GetRequest('token'))
            this.$router.push({path: '/sharingcenter'})
          }
        } else {
          // this.$message.error("登录失败，请重试");
        }
      }
  }
}
</script>
<style lang="scss">
.login_content_bg {
  background: url("../../assets/images/bg.png") no-repeat center top;
  background-size: 100% 100%;
  overflow: hidden;
  height: 100%;
  position: relative;

  .login_content_box {
    width: 1000px;
    overflow: hidden;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -290px 0 0 -500px;

    .login_content_banner {
      width: 530px;
      height: 580px;
      /*background: url("../../assets/images/pic1.png") no-repeat center top;*/
      /*background-size: 100% 100%;*/
      float: left;
      .el-carousel{width:530px; position: absolute;left:0;top:0;}
      .el-carousel__container{height:580px;}
      .el-carousel__item{text-align: center;}
      .banner_img{
        width: 530px;
        height: 580px;
        display: inline-block;
      }
    }

    .login_content_logs {
      float: right;
      width: 470px;
      overflow: hidden;
      box-sizing: border-box;
      padding: 32px 80px 40px 80px;

      .login_content_logo {
        width: 100%;
        height: 60px;
        text-align: center;
      }

      .login_content_texts {
        font-size: 22px;
        text-align: center;
        font-weight: bold;
        margin-top: 5px;
      }

      .login_content_tabs {
        width: 100%;
        height: 35px;
        margin-top: 20px;

        .login_content_tabs_left {
          width: 50%;
          float: left;
          text-align: center;
          line-height: 35px;
          border-bottom: 2px solid #e5e5e5;
        }

        .login_content_tabs_left:hover {
          color: #15c1e4;
          cursor: pointer;
        }
      }

      .login_content_user {
        width: 100%;
        overflow: hidden;

        .login_content_user_account {
          width: 100%;
          overflow: hidden;
          box-sizing: border-box;
          padding-top: 25px;

          .login_content_user_account_zd {
            width: 100%;
            height: 60px;
            padding-top: 25px;
            box-sizing: border-box;

            span:nth-child(2) {
              margin-left: 5px;
              display: inline-block;
              cursor: pointer;
              margin-right: 5px;
              color: #cccccc;
            }

            span:nth-child(3) {
              float: right;
              cursor: pointer;
            }

            span:nth-child(4) {
              cursor: pointer;
            }
          }

          .login_content_user_account_btn {
            width: 100%;
            overflow: hidden;

            div {
              width: 100%;
              text-align: center;
              background: #15c1e4;
              color: #fff;
              line-height: 40px;
              height: 39px;
              border-radius: 4px;
              cursor: pointer;
              margin-top: 10px;
            }
          }
        }

        .login_content_user_third_party {
          width: 100%;
          box-sizing: border-box;
          position: relative;
          height: 40px;

          .login_content_user_third_party_one {
            width: 100%;
            border: 0.5px solid #999999;
            margin-top: 50px;
          }

          span {
            font-size: 12px;
            color: #cccccc;
            background: #fff;
            position: absolute;
            z-index: 2;
            top: -8px;
            left: 32%;
            width: 116px;
            text-align: center;
          }

          .login_content_user_third_party_authorization {
            margin-top: 10px;

            ul {
              width: 100%;

              li {
                width: 100%;
                float: left;
                height: 50px;
                text-align: center;
                box-sizing: border-box;
                padding-top: 19px;

                img {
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
  }
}

.tab_cur {
  color: #15c1e4;
  font-weight: bold;
  border-bottom: 2px solid #15c1e4 !important;
}

.login_content_password_set {
  margin-top: 20px;
}

.login_content_code {
  margin-top: 26px;
  width: 170px;
}

.login_content_code_btn {
  float: right;
  margin-top: 26px;
  color: #15c1e4;
}

.cur_color {
  color: red;
  position: relative;
  bottom: -3px;
  // float: left;
}

.el-message .el-message--error {
  margin-top: 200px;
}

.login_content_st {
  box-sizing: border-box;
  padding: 20px 0px 20px 0px;

  .login_content_cur {
    display: inline-block;
    width: 60px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-radius: 5px;
    margin-left: 20px;
    border: 1px solid #15c1e4;
    cursor: pointer;
  }

  .login_content_cur_tl {
    display: inline-block;
    width: 60px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #15c1e4;
    margin-left: 35px;
    border-radius: 5px;
    cursor: pointer;
  }
}

.cur_hover {
  height: 130px;
  background: #15c1e4;
  color: #fff;
}

.log_lp {
  text-align: right;
  padding-top: 10px;

  span {
    color: #15c1e4;
    cursor: pointer;
  }
}
</style>
